import React from 'react';
import { Link } from 'react-router-dom';
import LogoutIcon from '../icons/LogoutIcon';
import Logo from '../Logo';
import Frame from './components/Frame';
import Wrapper from './components/Wrapper';
import { ISideMenu } from './interface';

function SideMenu(props: ISideMenu) {
  return (
    <Frame.Base>
      <Wrapper.Buttons>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Logo width="100%" color="#FFFFFF" />
        </Link>
        {props.children}
      </Wrapper.Buttons>
      <Wrapper.Logout>
        <LogoutIcon />
      </Wrapper.Logout>
    </Frame.Base>
  );
}

export default SideMenu;
